import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const COUNTRIES = [
  { code: 'IT', it: 'Italia', en: 'Italy', fr: 'Italie', de: 'Italien', es: 'Italia', nl: 'Italië', pl: 'Włochy', pt: 'Itália' },
  { code: 'FR', it: 'Francia', en: 'France', fr: 'France', de: 'Frankreich', es: 'Francia', nl: 'Frankrijk', pl: 'Francja', pt: 'França' },
  { code: 'DE', it: 'Germania', en: 'Germany', fr: 'Allemagne', de: 'Deutschland', es: 'Alemania', nl: 'Duitsland', pl: 'Niemcy', pt: 'Alemanha' },
  { code: 'ES', it: 'Spagna', en: 'Spain', fr: 'Espagne', de: 'Spanien', es: 'España', nl: 'Spanje', pl: 'Hiszpania', pt: 'Espanha' },
  { code: 'CH', it: 'Svizzera', en: 'Switzerland', fr: 'Suisse', de: 'Schweiz', es: 'Suiza', nl: 'Zwitserland', pl: 'Szwajcaria', pt: 'Suíça' },
  { code: 'AT', it: 'Austria', en: 'Austria', fr: 'Autriche', de: 'Österreich', es: 'Austria', nl: 'Oostenrijk', pl: 'Austria', pt: 'Áustria' },
  { code: 'NL', it: 'Paesi Bassi', en: 'Netherlands', fr: 'Pays-Bas', de: 'Niederlande', es: 'Países Bajos', nl: 'Nederland', pl: 'Holandia', pt: 'Países Baixos' },
  { code: 'BE', it: 'Belgio', en: 'Belgium', fr: 'Belgique', de: 'Belgien', es: 'Bélgica', nl: 'België', pl: 'Belgia', pt: 'Bélgica' },
  { code: 'GB', it: 'Regno Unito', en: 'United Kingdom', fr: 'Royaume-Uni', de: 'Vereinigtes Königreich', es: 'Reino Unido', nl: 'Verenigd Koninkrijk', pl: 'Wielka Brytania', pt: 'Reino Unido' },
  { code: 'US', it: 'Stati Uniti', en: 'United States', fr: 'États-Unis', de: 'USA', es: 'Estados Unidos', nl: 'Verenigde Staten', pl: 'Stany Zjednoczone', pt: 'Estados Unidos' },
  { code: 'PT', it: 'Portogallo', en: 'Portugal', fr: 'Portugal', de: 'Portugal', es: 'Portugal', nl: 'Portugal', pl: 'Portugalia', pt: 'Portugal' },
  { code: 'PL', it: 'Polonia', en: 'Poland', fr: 'Pologne', de: 'Polen', es: 'Polonia', nl: 'Polen', pl: 'Polska', pt: 'Polónia' },
  { code: 'OTHER', it: 'Altro', en: 'Other', fr: 'Autre', de: 'Andere', es: 'Otro', nl: 'Anders', pl: 'Inne', pt: 'Outro' },
];

const i18n = {
  title: { it: 'Diventa nostro Partner', en: 'Become our Partner', fr: 'Devenez notre Partenaire', de: 'Werde unser Partner', es: 'Conviértete en nuestro Socio', nl: 'Word onze Partner', pl: 'Zostań naszym Partnerem', pt: 'Torna-te nosso Parceiro' },
  subtitle: { it: 'Presentaci proprietari della tua zona e guadagna sui ricavi.', en: 'Refer owners from your area and earn on the revenue.', fr: 'Présentez-nous des propriétaires de votre région et gagnez sur les revenus.', de: 'Empfehle uns Eigentümer aus deiner Gegend und verdiene am Umsatz.', es: 'Preséntanos propietarios de tu zona y gana sobre los ingresos.', nl: 'Stel eigenaren uit je buurt aan ons voor en verdien aan de inkomsten.', pl: 'Polecaj nam właścicieli z Twojej okolicy i zarabiaj na przychodach.', pt: 'Apresenta-nos proprietários da tua zona e ganha sobre os rendimentos.' },
  yourContact: { it: 'I tuoi contatti', en: 'Your contacts', fr: 'Vos contacts', de: 'Deine Kontakte', es: 'Tus contactos', nl: 'Jouw contactgegevens', pl: 'Twoje dane kontaktowe', pt: 'Os teus contactos' },
  zoneData: { it: 'La tua zona di residenza', en: 'Your residence area', fr: 'Votre zone de résidence', de: 'Dein Wohnort', es: 'Tu zona de residencia', nl: 'Jouw woongebied', pl: 'Twój obszar zamieszkania', pt: 'A tua zona de residência' },
  country: { it: 'Paese', en: 'Country', fr: 'Pays', de: 'Land', es: 'País', nl: 'Land', pl: 'Kraj', pt: 'País' },
  comune: { it: 'Comune di residenza', en: 'Your city / town', fr: 'Votre commune', de: 'Deine Gemeinde', es: 'Tu municipio', nl: 'Jouw gemeente', pl: 'Twoja gmina', pt: 'O teu município' },
  experienceQ: { it: 'Hai esperienza nel mercato delle case vacanza?', en: 'Do you have experience in the holiday rental market?', fr: 'Avez-vous de l\'expérience dans la location de vacances ?', de: 'Hast du Erfahrung im Ferienvermietungsmarkt?', es: '¿Tienes experiencia en el mercado de alquiler vacacional?', nl: 'Heb je ervaring in de vakantieverhuurmarkt?', pl: 'Czy masz doświadczenie na rynku najmu wakacyjnego?', pt: 'Tens experiência no mercado de casas de férias?' },
  expYes: { it: 'Sì', en: 'Yes', fr: 'Oui', de: 'Ja', es: 'Sí', nl: 'Ja', pl: 'Tak', pt: 'Sim' },
  expNo: { it: 'No', en: 'No', fr: 'Non', de: 'Nein', es: 'No', nl: 'Nee', pl: 'Nie', pt: 'Não' },
  expDesc: { it: 'Descrivi brevemente la tua esperienza (opzionale)', en: 'Briefly describe your experience (optional)', fr: 'Décrivez brièvement votre expérience (optionnel)', de: 'Beschreibe kurz deine Erfahrung (optional)', es: 'Describe brevemente tu experiencia (opcional)', nl: 'Beschrijf kort je ervaring (optioneel)', pl: 'Opisz krótko swoje doświadczenie (opcjonalnie)', pt: 'Descreve brevemente a tua experiência (opcional)' },
  expDescHint: { it: 'es. Ho gestito un B&B per 3 anni...', en: 'e.g. I managed a B&B for 3 years...', fr: 'ex. J\'ai géré un B&B pendant 3 ans...', de: 'z. B. Ich habe 3 Jahre ein B&B geführt...', es: 'ej. Gestioné un B&B durante 3 años...', nl: 'bijv. Ik heb 3 jaar een B&B gerund...', pt: 'ex. Geri um B&B durante 3 anos...' },
  consent: { it: 'Confermo di voler essere contattato dal team Holiday World per maggiori dettagli sul programma Partner.', en: 'I confirm I want to be contacted by Holiday World about the Partner program.', fr: 'Je confirme vouloir être contacté(e) par l\'équipe Holiday World au sujet du programme Partenaire.', de: 'Ich bestätige, dass ich vom Holiday-World-Team zum Partnerprogramm kontaktiert werden möchte.', es: 'Confirmo que quiero ser contactado por el equipo Holiday World sobre el programa Partner.', nl: 'Ik bevestig dat ik door het Holiday World-team gecontacteerd wil worden over het Partner-programma.', pl: 'Potwierdzam, że chcę być kontaktowany przez zespół Holiday World w sprawie programu Partnerskiego.', pt: 'Confirmo que quero ser contactado pela equipa Holiday World sobre o programa de Parceiros.' },
  disclaimer: { it: 'Riceverai a breve un messaggio WhatsApp con tutti i dettagli del programma. Nessun impegno, nessun costo.', en: 'You will shortly receive a WhatsApp message with all program details. No commitment, no cost.', fr: 'Vous recevrez bientôt un message WhatsApp avec tous les détails du programme. Sans engagement.', de: 'Du erhältst in Kürze eine WhatsApp-Nachricht mit allen Details zum Programm. Unverbindlich.', es: 'Recibirás pronto un mensaje de WhatsApp con todos los detalles. Sin compromiso.', nl: 'Je ontvangt binnenkort een WhatsApp-bericht met alle programmadetails. Vrijblijvend, kosteloos.', pl: 'Wkrótce otrzymasz wiadomość WhatsApp z pełnymi szczegółami programu. Bez zobowiązań.', pt: 'Receberás brevemente uma mensagem de WhatsApp com todos os detalhes do programa. Sem compromisso.' },
  submit: { it: 'Sì, sono interessato', en: 'Yes, I\'m interested', fr: 'Oui, je suis intéressé(e)', de: 'Ja, ich bin interessiert', es: 'Sí, estoy interesado', nl: 'Ja, ik ben geïnteresseerd', pl: 'Tak, jestem zainteresowany', pt: 'Sim, tenho interesse' },
  cancel: { it: 'Annulla', en: 'Cancel', fr: 'Annuler', de: 'Abbrechen', es: 'Cancelar', nl: 'Annuleren', pl: 'Anuluj', pt: 'Cancelar' },
  required: { it: 'Compila i campi obbligatori', en: 'Please fill required fields', fr: 'Remplissez les champs obligatoires', de: 'Bitte Pflichtfelder ausfüllen', es: 'Completa los campos obligatorios', nl: 'Vul de verplichte velden in', pl: 'Wypełnij wymagane pola', pt: 'Preenche os campos obrigatórios' },
};
const T = (k, lang) => (i18n[k] && i18n[k][lang]) || i18n[k]?.it || k;

export default function PartnerLeadForm({ token, language, onClose, onSuccess, inline = false }) {
  const L = (language || 'it').toLowerCase();
  const [prefill, setPrefill] = useState(null);
  const [guestCountry, setGuestCountry] = useState('IT');
  const [guestComune, setGuestComune] = useState('');
  const [hasExperience, setHasExperience] = useState(null); // true | false | null
  const [experienceDescription, setExperienceDescription] = useState('');
  const [consent, setConsent] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(`${API}/public/guest-video/${token}/prefill`);
        setPrefill(r.data);
        if (r.data.country) setGuestCountry(r.data.country);
      } catch (_) {
        setPrefill({ first_name: '', last_name: '', email: '', phone: '' });
      }
    })();
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!guestComune.trim() || !consent) {
      setError(T('required', L));
      return;
    }
    setSubmitting(true);
    try {
      const payload = {
        guest_country: guestCountry,
        guest_comune: guestComune.trim(),
        consent: true,
      };
      if (hasExperience !== null) {
        payload.has_experience = hasExperience;
        if (hasExperience && experienceDescription.trim()) {
          payload.experience_description = experienceDescription.trim();
        }
      }
      await axios.post(`${API}/public/guest-video/${token}/partner-lead`, payload);
      onSuccess && onSuccess();
    } catch (e) {
      setError(e.response?.data?.detail || 'Errore invio');
    } finally {
      setSubmitting(false);
    }
  };

  const content = (
      <div className={inline ? 'bg-white w-full rounded-3xl overflow-hidden shadow-xl shadow-blue-100/60 border border-blue-100' : 'bg-white w-full max-w-md max-h-[95vh] overflow-y-auto rounded-t-3xl sm:rounded-3xl shadow-2xl'}>
        <div className="sticky top-0 bg-gradient-to-r from-blue-700 to-indigo-600 text-white px-5 py-4 sm:rounded-t-3xl flex items-center justify-between">
          <div>
            <h2 className="text-lg font-bold">{T('title', L)}</h2>
            <p className="text-xs text-blue-100 mt-0.5">{T('subtitle', L)}</p>
          </div>
          {!inline && (
            <button onClick={onClose} className="text-white/80 hover:text-white text-2xl leading-none p-1" data-testid="partner-lead-close" aria-label="Close">×</button>
          )}
        </div>

        <form onSubmit={handleSubmit} className="p-5 space-y-5">
          {/* Recapiti pre-compilati */}
          <div>
            <h3 className="text-xs font-bold text-slate-500 uppercase tracking-wide mb-2">{T('yourContact', L)}</h3>
            <div className="bg-slate-50 border border-slate-200 rounded-xl p-3 space-y-1.5 text-sm">
              <div><span className="text-slate-500">👤</span> <strong>{prefill?.first_name || '...'} {prefill?.last_name || ''}</strong></div>
              <div><span className="text-slate-500">✉️</span> {prefill?.email || '...'}</div>
              <div><span className="text-slate-500">📱</span> {prefill?.phone || '...'}</div>
            </div>
          </div>

          {/* Zona */}
          <div>
            <h3 className="text-xs font-bold text-slate-500 uppercase tracking-wide mb-2">{T('zoneData', L)}</h3>
            <div className="space-y-3">
              <div>
                <label className="text-xs text-slate-600 font-medium mb-1 block">{T('country', L)} *</label>
                <select
                  value={guestCountry}
                  onChange={(e) => setGuestCountry(e.target.value)}
                  className="w-full border border-slate-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  data-testid="partner-lead-country"
                  required
                >
                  {COUNTRIES.map(c => (
                    <option key={c.code} value={c.code}>{c[L] || c.it}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="text-xs text-slate-600 font-medium mb-1 block">{T('comune', L)} *</label>
                <input
                  type="text"
                  value={guestComune}
                  onChange={(e) => setGuestComune(e.target.value)}
                  className="w-full border border-slate-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder={L === 'it' ? 'es. Cogoleto' : 'e.g. Cogoleto'}
                  data-testid="partner-lead-comune"
                  required
                />
              </div>
              <div>
                <label className="text-xs text-slate-600 font-medium mb-1 block">{T('experienceQ', L)}</label>
                <div className="flex gap-2" data-testid="partner-lead-experience">
                  <button
                    type="button"
                    onClick={() => setHasExperience(true)}
                    className={`flex-1 py-2.5 rounded-lg border-2 text-sm font-semibold transition-colors ${hasExperience === true ? 'bg-blue-600 border-blue-600 text-white' : 'bg-white border-slate-300 text-slate-600 hover:border-blue-400'}`}
                    data-testid="partner-lead-exp-yes"
                  >{T('expYes', L)}</button>
                  <button
                    type="button"
                    onClick={() => { setHasExperience(false); setExperienceDescription(''); }}
                    className={`flex-1 py-2.5 rounded-lg border-2 text-sm font-semibold transition-colors ${hasExperience === false ? 'bg-blue-600 border-blue-600 text-white' : 'bg-white border-slate-300 text-slate-600 hover:border-blue-400'}`}
                    data-testid="partner-lead-exp-no"
                  >{T('expNo', L)}</button>
                </div>
              </div>
              {hasExperience === true && (
                <div>
                  <label className="text-xs text-slate-600 font-medium mb-1 block">{T('expDesc', L)}</label>
                  <textarea
                    value={experienceDescription}
                    onChange={(e) => setExperienceDescription(e.target.value)}
                    rows={3}
                    maxLength={1000}
                    className="w-full border border-slate-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
                    placeholder={T('expDescHint', L)}
                    data-testid="partner-lead-exp-desc"
                  />
                </div>
              )}
            </div>
          </div>

          {/* Consenso */}
          <label className="flex items-start gap-2 p-3 bg-blue-50 border border-blue-200 rounded-lg cursor-pointer">
            <input
              type="checkbox"
              checked={consent}
              onChange={(e) => setConsent(e.target.checked)}
              className="mt-0.5 w-4 h-4 text-blue-600 rounded"
              data-testid="partner-lead-consent"
            />
            <span className="text-xs text-blue-900 leading-snug">{T('consent', L)}</span>
          </label>

          {/* Disclaimer */}
          <div className="bg-amber-50 border-l-4 border-amber-400 p-3 text-xs text-amber-900 rounded-r-lg">
            ℹ️ {T('disclaimer', L)}
          </div>

          {error && (
            <div className="bg-rose-50 border border-rose-200 text-rose-700 text-sm p-3 rounded-lg" data-testid="partner-lead-error">{error}</div>
          )}

          <div className="flex gap-2 pt-2">
            {!inline && (
              <button
                type="button"
                onClick={onClose}
                className="flex-1 py-3 border-2 border-slate-300 text-slate-700 rounded-xl font-semibold text-sm hover:bg-slate-50"
                data-testid="partner-lead-cancel"
              >{T('cancel', L)}</button>
            )}
            <button
              type="submit"
              disabled={submitting || !consent}
              className="flex-1 py-3 bg-gradient-to-r from-blue-700 to-indigo-600 text-white rounded-xl font-semibold text-sm shadow-lg disabled:opacity-50"
              data-testid="partner-lead-submit"
            >{submitting ? '...' : T('submit', L)}</button>
          </div>
        </form>
      </div>
  );
  if (inline) return content;
  return (
    <div className="fixed inset-0 z-50 bg-slate-900/70 flex items-end sm:items-center justify-center p-0 sm:p-4 animate-in fade-in" data-testid="partner-lead-modal">
      {content}
    </div>
  );
}
